import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AddressService extends MainService {

	provinces: any = null;
	cities: any = null;
	streets: any = null;

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router
	) {
		super(http, toastService, storage, router);
	}

	getProvince(countryId: string = 'PH'){
		return new Promise(res => {
			if(!this.provinces){
				this.provinces = {};
			}
			if(this.provinces[countryId]){
				res(this.provinces[countryId])
			} else {
				let url = this.getStoreUrl('/V1/hnd-address-directory/regions/' + countryId);
				// this.makeRequest('/rest/entrelable/V1/lns-api/directory/'+countryId+'/region', null, 'GET').then(resolve => {
				this.makeRequest(url, null, 'GET').then(resolve => {
					this.provinces[countryId] = resolve;
					res(resolve);
				});
			}
		});
	}

	getCity(countryId: string = 'PH', provinceId:any = null){
		return new Promise(res => {
			if(!this.cities){
				this.cities = {};
			}

			if(this.cities[provinceId]){
				res(this.cities[provinceId])
			} else {
				let url = this.getStoreUrl('/V1/hnd-address-directory/cities/' + provinceId);
				// this.makeRequest('/rest/entrelable/V1/lns-api/directory/'+countryId+'/'+provinceId, null, 'GET').then(resolve => {
				this.makeRequest(url, null, 'GET').then(resolve => {
					this.cities[provinceId] = resolve;
					res(resolve);
				});
			}
		});
	}

	

	getStreet(regionCode, cityCode){
		return new Promise(res => {
			if(!this.streets){
				this.streets = {};
			}
			if(typeof this.streets[regionCode] == 'undefined'){
				this.streets[regionCode] = {};
			}


			if(this.streets[regionCode][cityCode]){
				res(this.streets[regionCode][cityCode]);
			} else {
				let url = this.getStoreUrl('/V1/hnd-address-directory/street/' + regionCode + '/' + cityCode);
				// this.makeRequest('/rest/entrelable/V1/lns-api/directory/'+countryId+'/'+provinceId, null, 'GET').then(resolve => {
				this.makeRequest(url, null, 'GET').then(resolve => {
					this.streets[regionCode][cityCode] = resolve;
					res(resolve);
				});
			}
		});
	}
}
